import '@assets/sass/app.scss'
import '@/scss/variables.scss'

import { checkCurrentLang } from './plugins/i18n'
import router from './router'
import { initData as initDataAuth } from './service/http/auth'
import store from './store'
import { sync } from './store/store-router'

require('./components')
require('./global-mixin')
require('./plugins')
require('./filters')

checkCurrentLang()
sync(store, router)
initDataAuth()
export { router, store }
